import React from "react";
import style from "./timer-toggle.module.css";
import cn from "classnames";
import { useIsCIMReorderEnabled } from "utils/url-utils";

const minimizeButton = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.02884 9.17136L18.0492 9.17136V10.8286L2.02884 10.8286V9.17136Z"
      fill="currentColor"
    />
  </svg>
);

const closeButton = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99899 8.79868L16.7977 2L17.9994 3.20175L11.2007 10.0004L17.9986 16.7982L16.7968 18L9.99899 11.2022L3.20263 17.9985L2.00088 16.7967L8.79724 10.0004L2 3.20321L3.20174 2.00146L9.99899 8.79868Z"
      fill="currentColor"
    />
  </svg>
);

export enum Sign {
  Minimize = "minimize",
  Close = "close",
}

const TimerToggle = ({
  sign,
  resetTimer,
  setShowTimer,
}: {
  sign: string;
  resetTimer: () => void;
  setShowTimer: (show: boolean) => void;
}) => {
  const isCimReorderEnabled = useIsCIMReorderEnabled();
  function handleClick() {
    setShowTimer(false);
    if (sign === Sign.Close) {
      resetTimer();
    }
  }
  return (
    <div className={cn(style.toggleTimer, { [style.cimPosition]: isCimReorderEnabled })}>
      <button className={style.toggleTimerButton} onClick={() => handleClick()} data-testid="timer-toggle-button">
        {sign === Sign.Minimize ? minimizeButton : closeButton}
      </button>
    </div>
  );
};

export default TimerToggle;
